import * as React from "react"
import { Layout, Seo } from "@/components"
import { HeaderBar } from "./header-bar"
import Content from "./content"

const SinglePage: React.FC<SinglePageTemplate> = ({
  pageContext: {
    singlePage: { seoTitle, SeoDescription, seoKeyword, title, body },
  },
}) => {
  return (
    <Layout>
      <Seo title={seoTitle} description={SeoDescription} keywords={seoKeyword} />
      <HeaderBar title={title} />
      <Content body={body} />
    </Layout>
  )
}

export default SinglePage
